import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_DRIVER_TARIFF_BY_DRIVER_ID } from '../graphql/driverTariffs';

const DAY_RATE_MAP = {
    0: 'SUNDAY_RATE',
    1: 'MONDAY_RATE',
    2: 'TUESDAY_RATE',
    3: 'WEDNESDAY_RATE',
    4: 'THURSDAY_RATE',
    5: 'FRIDAY_RATE',
    6: 'SATURDAY_RATE',
};

export const useDriverPay = (route, enabled) => {
    const { data, loading } = useQuery(GET_DRIVER_TARIFF_BY_DRIVER_ID, {
        skip: !enabled || !route?.driver_id,
        variables: { driver_id: route?.driver_id },
        fetchPolicy: 'cache-first',
    });

    const driverPay = useMemo(() => {
        if (!enabled || !route?.driver_id || !route?.scheduled_delivery || loading) {
            return null;
        }

        const driverTariffMapping = data?.driver_tariff_mappings?.[0];
        if (!driverTariffMapping) {
            return '0.00';
        }

        const tariff = driverTariffMapping.tariff;
        if (!tariff || tariff.algo_type !== 'DRIVER_DAILY_FLAT') {
            return '0.00';
        }

        // Get day of week from scheduled_delivery (0 = Sunday, 6 = Saturday)
        const scheduledDate = new Date(route.scheduled_delivery);
        const dayOfWeek = scheduledDate.getDay();
        const rateType = DAY_RATE_MAP[dayOfWeek];

        // Find the matching rate for the day
        const dayRate = tariff.rates?.find((rate) => rate.type === rateType);

        if (!dayRate || dayRate.rate == null) {
            return '0.00';
        }

        return parseFloat(dayRate.rate).toFixed(2);
    }, [data, route, enabled, loading]);

    return { driverPay, loading };
};
